import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type DocumentDashboard } from '../../api/documents';

const NAV = [
  { to: '/documents/repository', label: 'Repository Browser' },
  { to: '/documents/folders', label: 'Folder Manager' },
  { to: '/documents/ocr', label: 'OCR Review' },
  { to: '/documents/extraction', label: 'AI Extraction Viewer' },
  { to: '/documents/signatures', label: 'Signature Center' },
  { to: '/documents/search', label: 'Search Console' },
  { to: '/documents/compliance', label: 'Compliance Dashboard' },
];

export function DocumentCenterPage() {
  const [dashboard, setDashboard] = useState<DocumentDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void documentsApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total Documents', value: dashboard.total_documents },
        { label: 'Active', value: dashboard.active_documents },
        { label: 'Archived', value: dashboard.archived_documents },
        { label: 'Folders', value: dashboard.total_folders },
        { label: 'OCR (24h)', value: dashboard.ocr_processed_24h },
        { label: 'Pending Signatures', value: dashboard.pending_signatures },
        { label: 'Completed Signatures', value: dashboard.completed_signatures },
        { label: 'Retention Policies', value: dashboard.retention_policies },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Document Center</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise document management, OCR, digital signature and compliance platform.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
      {dashboard?.recent_activity && dashboard.recent_activity.length > 0 && (
        <div className="mt-8">
          <h2 className="text-lg font-medium">Recent Activity</h2>
          <ul className="mt-3 space-y-2">
            {dashboard.recent_activity.map((a) => (
              <li key={a.id} className="rounded-lg border p-3 text-sm dark:border-slate-700">
                <span className="font-medium">{a.action}</span> — {a.message}
                <span className="ml-2 text-slate-500">{new Date(a.created_at).toLocaleString()}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
